import { useEffect, useContext } from 'react'
import cn from 'classnames'
import { useAtom } from 'jotai/index'
import { isMobileOnly } from 'react-device-detect'
import ProjectsList from './components/ProjectsList'
import HelpButton from './components/HelpButton'
import * as atoms from './atoms'
import styles from './ProjectNavigation.module.scss'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import { AuthContext } from '../../../context/firebase-context'

const ProjectNavigation = ({ children }) => {
  const { themeMode } = useTheme()
  const user = useContext(AuthContext)
  const [, loadProjects] = useAtom(atoms.loadProjects)
  const [, loadScripts] = useAtom(atoms.loadScripts)

  useEffect(() => {
    loadProjects()
    loadScripts()
  }, [])

  return (
    <div className={cn(styles.rootWrapper, styles[themeMode], { [styles.withMargin]: !user.emailVerified })}>
      {!isMobileOnly && (
        <div className={cn(styles.projectMainNav, styles[themeMode])}>
          <div data-testid='rail-scroll' className={cn(styles.scrollSection, styles[themeMode])}>
            <ProjectsList />
          </div>
          <div className={cn(styles.navFooter, styles[themeMode])}>
            <HelpButton />
          </div>
        </div>
      )}
      <main className={cn(styles.mainContainerWrapper, styles[themeMode])}>
        {children}
      </main>
    </div>
  )
}

export default ProjectNavigation
